import React, { Component } from "react";
import { Card, Button, Header } from "semantic-ui-react";
import PropTypes from "prop-types";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
// import Utils from "../utilities/Utils";
import { connect } from "react-redux";
import { solveProblemAction } from "../../actions/changeActiveItemActions";
// const UtilsInstance = new Utils();

export class ProblemCard extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {};
  }

  getProblemHeader = () => {
    if (this.props.problem.type === Constants.RETRIES_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.DEVICE_WITH_RETRIES}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.DIAGNOSTIC_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.DEVICE_WITH_DIAGNOSTIC}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.FAULT_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.DEVICE_WITH_FAULT}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.FAULT_SEQUENCE_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.DEVICE_WITH_FAULT_SEQ}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.CONFIG_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.DEVICE_WITH_CONFIG_ERROR}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.PARAM_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.DEVICE_WITH_PARAM_ERROR}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.MISSING_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.DEVICE_MISSING}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.ONLINE_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.DEVICE_ONLINE}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.CRITICAL_SLAVE_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.DEVICE_IS_CRITICAL_SLAVE}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.MASTER_FAULT_ERROR_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.DEVICE_IS_MASTER_FAULT}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_LIST_HEADER}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_LIST_HEADER}
        </Card.Header>
      );
    }
    else if (this.props.problem.type === Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE) {
      return (
        <Card.Header style={{ marginBottom: "2px" }}>
          {Strings.FIBER_SIGNAL_LOSS_LIST_HEADER}
        </Card.Header>
      );
    }
    else {
      return "";
    }
  }

  formatTime = () => {
    if (this.props.problem.ntp !== null && this.props.problem.ntp === true && this.props.problem.time !== null) {
      let parsedMillis = Date.parse(this.props.problem.time);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString("pt-BR");
    }
    else if (this.props.problem.time !== undefined && this.props.problem.time !== null) {
      const eventTimeInMillis = this.props.problem.time * 1000;
      const timeNow = this.props.nowMillis;
      const time = timeNow - eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString("pt-BR"));
    }
    else {
      return Strings.BEFORE_MONITOR_INIT_STR;
    }
  }

  getProblemMeta = () => {
    let problemDate = this.formatTime();

    return (
      <Card.Meta>
        <strong>
          {Strings.DETECTED_ON}
          {problemDate}
        </strong>
      </Card.Meta>
    );
  }

  getProblemDescription = () => {
    if (this.props.problem.type === Constants.RETRIES_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <p>
              <b>{Strings.ADDRESS}:</b> {this.props.problem.address} <br />
              <b>{Strings.RETRIES_DP}</b>{this.props.problem.total} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.DIAGNOSTIC_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <p><b>{Strings.ADDRESS}:</b> {this.props.problem.address}</p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.FAULT_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <p>
              <b>{Strings.ADDRESS}:</b> {this.props.problem.address} <br />
              <b>{Strings.FAULT_DP}</b>{this.props.problem.total} <br />
            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.FAULT_SEQUENCE_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <Header as="h4" style={headerStyle}>{Strings.DEVICE}:</Header>
            <p>

            </p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.CONFIG_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <p><b>{Strings.ADDRESS}:</b> {this.props.problem.address}</p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.PARAM_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <p><b>{Strings.ADDRESS}:</b> {this.props.problem.address}</p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.MISSING_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <p><b>{Strings.ADDRESS}:</b> {this.props.problem.address}</p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.ONLINE_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <p><b>{Strings.ADDRESS}:</b> {this.props.problem.address}</p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.CRITICAL_SLAVE_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <p><b>{Strings.ADDRESS}:</b> {this.props.problem.address}</p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.MASTER_FAULT_ERROR_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <p><b>{Strings.ADDRESS}:</b> {this.props.problem.address}</p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE || this.props.problem.type === Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE) {
      let voltage = this.props.problem.voltage !== null ? parseFloat(this.props.problem.voltage).toFixed(2) : Strings.UNKNOWN;
      return (
        <React.Fragment>
          <Card.Description>
            <p><b>{Strings.OPTIC_FIBER}: </b> {this.selectFiber(this.props.problem.fiber)}</p>
            <p><b>{Strings.CHANNEL}: </b> {this.props.problem.channel}</p>
            <p><b>{Strings.VOLTAGE_}: </b> {voltage} V</p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else if (this.props.problem.type === Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE) {
      return (
        <React.Fragment>
          <Card.Description>
            <p><b>{Strings.OPTIC_FIBER}: </b> {this.selectFiber(this.props.problem.fiber)}</p>
          </Card.Description>
        </React.Fragment>
      );
    }
    else {
      return "";
    }
  }

  selectFiber = (FB) => {
    if (FB === "FB1") {
      return "1";
    } else if (FB === "FB2") {
      return "2";
    } else {
      return "-";
    }
  }

  handleSolvedButtonClick = async () => {
    this.props.onProblemSolve(true, this.props.problem);
  }

  render() {
    const buttonText = (this.props.problem.type === Constants.FIBER_LOWER_LIMIT_MAINTENANCE_REQUIRED_PROBLEM_TYPE ||
      this.props.problem.type === Constants.FIBER_LOWER_LIMIT_URGENT_MAINTENANCE_PROBLEM_TYPE ||
      this.props.problem.type === Constants.FIBER_SIGNAL_LOSS_PROBLEM_TYPE
    ) ? Strings.CLEAR : Strings.CHECKED;

    return (
      <Card id={this.props.problem._id} fluid raised>
        <Card.Content>
          {this.getProblemHeader()}
          {this.getProblemMeta()}
          {this.getProblemDescription()}
        </Card.Content>
        <Card.Content extra>
          <Button
            basic
            color='green'
            fluid
            onClick={this.handleSolvedButtonClick}>
            {buttonText}
          </Button>
        </Card.Content>
      </Card >
    );
  }
}

const mapStateToProps = state => ({
  active: state
});

const mapActionsToProps = {
  onProblemSolve: solveProblemAction
};

ProblemCard.propTypes = {
  nowMillis: PropTypes.number.isRequired,
  problem: PropTypes.object.isRequired,
  onProblemSolve: PropTypes.func
};

const headerStyle = {
  marginTop: "8px",
  marginBottom: "8px",
};

export default connect(mapStateToProps, mapActionsToProps)(ProblemCard);